export var PlayerState = /*#__PURE__*/ function(PlayerState) {
    PlayerState[PlayerState["Stopped"] = 0] = "Stopped";
    PlayerState[PlayerState["Playing"] = 1] = "Playing";
    PlayerState[PlayerState["Paused"] = 2] = "Paused";
    PlayerState[PlayerState["Rebuffering"] = 3] = "Rebuffering";
    PlayerState[PlayerState["Finished"] = 4] = "Finished";
    PlayerState[PlayerState["Seeking"] = 5] = "Seeking";
    // TODO revisit our definition of the seeking state, as we lose information as to whether seeking includes rebuffering
    PlayerState[PlayerState["Loading"] = 6] = "Loading";
    PlayerState[PlayerState["WaitingToLoad"] = 7] = "WaitingToLoad";
    return PlayerState;
}({});

//# sourceMappingURL=player-state.js.map